/**
 * Archivo: LoadingSpinner.js
 * Fecha: 2026-05-20
 * Descripción: Componente reutilizable de spinner de carga
 */

import React from 'react';

const LoadingSpinner = ({ mensaje = 'Cargando...', size = 40 }) => {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px',
      color: 'var(--agx-muted)',
    },
    spinner: {
      width: size,
      height: size,
      border: '3px solid var(--agx-skeleton)',
      borderTop: '3px solid var(--agx-pri2)',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    mensaje: {
      marginTop: '16px',
      fontSize: '14px',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.spinner} />
      <div style={styles.mensaje}>{mensaje}</div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
